import React, { useState } from 'react';
import { RotatingLines } from 'react-loader-spinner';
import moment from 'moment';
import MobileFileUploadComponent from '../../../../../common/components/mobile-file-upload.component';


const EwayBill = ({ quoteDetails, isLoading, packageItem, handleFileURlSubmit, handleBackSteps, handleSteps }: any) => {

    const startLocation = quoteDetails?.result?.Records[0]?.message?.order?.fulfillments[0]?.start?.location?.address
    const endLocation = quoteDetails?.result?.Records[0]?.message?.order?.fulfillments[0]?.end?.location?.address
    const pickupAddress = `${startLocation?.locality},${startLocation?.city},${startLocation?.state}-${startLocation?.area_code},${startLocation?.country}`
    const dropAddress = `${endLocation?.locality},${endLocation?.city},${endLocation?.state}-${endLocation?.area_code},${endLocation?.country}`
    const [currentIndex, setCurrentIndex] = useState(0);

    const handleRightScroll = () => {
        if (currentIndex < packageItem.length - 1) {
            setCurrentIndex(currentIndex + 1);
        }
    };

    const handleLeftScroll = () => {
        if (currentIndex > 0) {
            setCurrentIndex(currentIndex - 1)
        }
    };



    return (
        <div className="flex  flex-col justify-center items-center ">
            <div className=" m-3 overflow-auto w-full ">
                <div className="flex flex-col justify-center items-start p-4 space-y-2">
                    <div className="text-lg font-semibold">E-way bill</div>
                    <div className="text-sm font-normal">Upload the E-Way bill</div>
                    <div className=" w-full">
                        <MobileFileUploadComponent
                            handleFileURlSubmit={handleFileURlSubmit}
                            folder='shipping'
                            ownerId='0'
                        />
                    </div>

                </div>
            </div>
        </div>
    );
};

export default EwayBill;
